import { Routes } from '@angular/router';
import { AuthGuard, MaintenanceGuard } from '@infinitform/editor-features';

export const APP_ROUTES: Routes = [
  { path: '', redirectTo: '/flow-status', pathMatch: 'full' },
  {
    path: 'flow-status',
    loadChildren: () =>
      import('@infinitform/editor-features').then((m) => m.FLOW_STATUS_ROUTES),
  },
  {
    path: 'maintenance',
    loadChildren: () =>
      import('@infinitform/editor-features').then((m) => m.MAINTENANCE_ROUTES),
  },
  {
    path: 'mold/:project_id',
    loadChildren: () =>
      import('@infinitform/editor-features').then((m) => m.MOLD_ROUTES),
    canActivate: [AuthGuard, MaintenanceGuard],
  },
  {
    path: 'jaws/:project_id',
    loadChildren: () =>
      import('@infinitform/editor-features').then((m) => m.SOFTJAWS_ROUTES),
    canActivate: [AuthGuard, MaintenanceGuard],
  },
  {
    path: 'editor/:project_id',
    loadChildren: () =>
      import('@infinitform/editor-features').then((m) => m.EDITOR_ROUTES),
    canActivate: [AuthGuard, MaintenanceGuard],
  },
  {
    path: ':project_id',
    loadChildren: () =>
      import('@infinitform/editor-features').then((m) => m.PROJECT_LOADER_ROUTES),
    canActivate: [AuthGuard, MaintenanceGuard],
  },
];
